var _mask, _g, _g2, _path, _circle, _circle2, _path2, _g3, _path3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottts1767950125358(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sidesAntenna02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 160,
    height: 51
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 36,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 9h2v20h-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 28,
    width: 36,
    height: 32,
    rx: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidesAntenna02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#00897b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M0 38h180v38H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M160 8h2v20h-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 5,
    r: 4,
    fill: "#E1E6E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 4,
    r: 2,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "topPyramid-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 64,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m50 8 32 44H18L50 8Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#topPyramid-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#00897b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.8,
    d: "M50 4h30v48H50z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "faceRound02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 120
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 31v-1c.18-.48.4-1.5 1-3 .83-3.06 2.78-6.56 6-10C16.7 6.6 35.17 0 65 0s48.3 6.6 58 17c3.22 3.44 5.17 6.94 6 10 .6 1.5.82 2.52 1 3v40c0-.1-.03.5 0 1a53.93 53.93 0 0 1-1 6c-1.19 6-3.4 11.91-7 17-9.72 16.34-27.74 26-57 26s-47.28-9.66-57-26C4.4 88.91 2.2 83 1 77a53.95 53.95 0 0 1-1-6c.03-.45 0-1.32 0-1V31Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#faceRound02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h138v124H-4V-2Z",
    fill: "#00897b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 27,
    height: 8,
    rx: 4,
    fill: "#000",
    fillOpacity: 0.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 76)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 18,
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 24,
    r: 18,
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 15,
    fill: "#F1EEDA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 24,
    r: 15,
    fill: "#F1EEDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 15,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#000",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottts1767950125358);
export default __webpack_public_path__ + "static/media/bottts-1767950125358.4f66f21180a7bb2f0660adde25eacfef.svg";
export { ForwardRef as ReactComponent };